export const SECONDS_BEFORE_EXPIRY = 30;
